import { render, staticRenderFns } from "./pointPlan.vue?vue&type=template&id=c47922c6&scoped=true"
import script from "./pointPlan.vue?vue&type=script&lang=js"
export * from "./pointPlan.vue?vue&type=script&lang=js"
import style0 from "./pointPlan.vue?vue&type=style&index=0&id=c47922c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47922c6",
  null
  
)

export default component.exports